import React from "react";
import { Container, Row, Col, Image, Button } from "react-bootstrap";
import { Box, Typography } from "@mui/material";
// import servImg from "../Images/about-three.jpg";
import halfTransMark from "../Assets/Images/halfTransCity.png";
// import halfTrans from '../Images/halfTrans.png'
// import logoIcon from "../Images/logo-icon.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPhone, faArrowRight } from "@fortawesome/free-solid-svg-icons";
import { motion } from "framer-motion";
import bgDot from "../Assets/Images/bgDots.png";

const ServiceInfo3rd = () => {
  return (
    <>
      <Box sx={{ backgroundImage: `url(${bgDot})`, backgroundSize: "20%" }}>
        <Container className="paddingServInfo">
          <Row>
            <Col lg={6}>
              <motion.div
                initial={{ opacity: 0.5, y: 250 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, ease: "easeInOut" }}
                viewport={{ once: true }}
              >
                <Box className="serviceImgWrap relative">
                  <Box className="serviceImg">
                    <Image src={halfTransMark} className="img-fluid"></Image>
                  </Box>
                  {/* <Box className="serviceLogo">
                  <Box className="logoBg">
                    <Image src={logoIcon} className="img-fluid"></Image>
                  </Box>
                </Box> */}
                </Box>
              </motion.div>
            </Col>
            <Col lg={6} className="serRight-text">
              <motion.div
                initial={{ opacity: 0.5, y: 250 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.9, ease: "easeInOut" }}
                viewport={{ once: true }}
              >
                <Typography variant="h6" color="">
                  What will you get
                </Typography>
                <motion.div
                  initial={{ clipPath: "inset(0 100% 0 0)" }}
                  whileInView={{ clipPath: "inset(0 0% 0 0)" }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.5, ease: "easeInOut" }}
                  style={{ display: "inline-block", overflow: "hidden" }}
                >
                  <Typography variant="h2">
                    Redefining Air Travel with Purpose, Precision, and Care.
                  </Typography>
                </motion.div>
                <Typography variant="body1" component="p">
                  Shankh Air is a next-generation full-service airline committed
                  to redefining the standards of domestic air travel. With a
                  strong emphasis on operational excellence, passenger comfort,
                  and service integrity, we offer a seamless and elevated travel
                  experience designed around the needs of today’s discerning
                  traveller. Our mission is to make air travel more accessible,
                  efficient, and customer-focused, connecting people and
                  opportunities with precision and care.
                </Typography>
                <Typography variant="body1" component="p">
                  Every journey with us reflects our core values: safety,
                  punctuality, and a personalized approach to service. From the
                  moment you choose to fly with us, your comfort, safety, and
                  satisfaction become our highest priority. With every detail
                  thoughtfully considered—whether in the air or on the
                  ground—our goal is to make you feel respected, supported, and
                  at ease.
                </Typography>
                <Box className="text-bottom">
                  <div className="btnWrapper">
                    <Button
                      variant="link"
                      className="coverBtn bg-green mb-0 btnIcon"
                    >
                      <span
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "5px",
                        }}
                      >
                        Discover More{" "}
                        <FontAwesomeIcon
                          style={{ margin: "0px 0 -1px 4px;" }}
                          icon={faArrowRight}
                        />
                      </span>
                    </Button>
                  </div>
                  <Box className="callInfo" as="a" href="tel:1234567890">
                    <FontAwesomeIcon icon={faPhone} />
                    <Typography variant="body1" component="span">
                      +91 (99351) 52025
                    </Typography>
                  </Box>
                </Box>
              </motion.div>
            </Col>
          </Row>
        </Container>
      </Box>
    </>
  );
};

export default ServiceInfo3rd;
